<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-vertical-centers-align`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24.712 28.293l7.778 7.778a1 1 0 010 1.414L31.076 38.9a1 1 0 01-1.414 0l-3.665-3.665V45a1 1 0 01-1 1h-2a1 1 0 01-1-1v-9.748L18.348 38.9a1 1 0 01-1.414 0l-1.414-1.415a1 1 0 010-1.414l7.778-7.778a1 1 0 011.414 0zM43 22a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1v-2a1 1 0 011-1h38zM23.004 2h2a1 1 0 01.993.884l.007.117v9.764L29.67 9.1a1 1 0 011.32-.083l.095.084 1.414 1.414a1 1 0 01.083 1.32l-.083.094-7.778 7.778a1 1 0 01-1.32.083l-.095-.083-7.778-7.778a1 1 0 01-.083-1.32l.083-.094L16.941 9.1a1 1 0 011.32-.083l.095.084 3.648 3.648V3a1 1 0 01.884-.993L23.004 2h2-2z"/></svg>
</template>
<script>

export default {
  name: 'IconVerticalCentersAlign',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
